<template>
  <div>
    <div class="alert alert-primary" role="alert">
      Welcome to Ateriad Iot
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";

export default {
  name: "dashboard",
  components: {},
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "داشبورد" }]);
    this.$store.dispatch(SET_ACTIONS, {});
  },
  computed: {},
  methods: {}
};
</script>
